<template>
  <section class="our-story-section" ref="storySection" id="About">
    <div class="story-container">
      <div class="story-image" ref="imageSection">
        <img src="/Images/jakub-dziubak-XtUd5SiX464-unsplash.jpg" alt="Coffee Cup" loading="eager">
      </div>

      <div class="story-content" ref="contentSection">
        <h2 class="story-title">Our Story</h2>
        <p class="story-text">
          Brewtopia Cafe opened its doors in 2020 with a simple mission: to bring people together over exceptional coffee. We source our beans from sustainable farms and roast them to perfection. Whether you're here for a quick espresso or a lazy afternoon, we've created a space where everyone feels at home.
        </p>

        <div class="features-grid">
          <div class="feature-item" v-for="(feature, index) in features" :key="index">
            <div class="feature-icon" v-html="feature.icon"></div>
            <h3 class="feature-title">{{ feature.title }}</h3>
            <p class="feature-description">{{ feature.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'OurStory',
  data() {
    return {
      features: [
        {
          icon: `<svg xmlns="http://www.w3.org/2000/svg" width="30.63px" height="35px" viewBox="0 0 448 512">
	<path fill="#D4A574" d="M375.164 239.324v-19.388c0-11.092-8.988-20.082-20.082-20.082H65.276c-11.092 0-20.082 8.99-20.082 20.082v64.936c0 90.975 74.012 164.985 164.985 164.985c55.721 0 104.988-27.832 134.873-70.253h32.133c38.712 0 70.201-31.494 70.201-70.206c-1.115-46.553-39.391-71.217-72.222-70.074M210.18 409.694c-68.826 0-124.821-55.996-124.821-124.822v-44.855H335v44.855c0 68.826-55.996 124.822-124.822 124.822m155.801-70.738c7.012-20.626 9.672-39.688 9.238-58.705c16.367-2.31 31.654 12.39 31.52 29.147c-1.143 18.711-13.912 31.846-40.758 29.558M220.6 137.004h-25.28v25.28c0 19.676-30.161 19.676-30.161 0v-25.28h-25.28c-19.957 0-19.957-30.16 0-30.16h25.28v-25.28c0-19.964 30.16-19.964 30.16 0v25.28h25.28c20.28 0 20.28 30.16 0 30.16m86.692-66.537h-25.275v25.28c-.209 20.277-30.396 20.26-30.166 0v-25.28h-25.278c-20.12 0-20.12-30.16 0-30.16h25.278V15.025c0-20.035 30.166-20.035 30.166 0v25.28h25.275c20.135 0 20.135 30.161 0 30.161M401.469 512H20.158c-26.877 0-26.877-40.164 0-40.164h381.311c26.77 0 26.77 40.164 0 40.164" />
</svg>`,
          title: 'Premium Beans',
          description: 'Ethically sourced from around the world'
        },
        {
          icon:`<svg xmlns="http://www.w3.org/2000/svg" width="35px" height="35px" viewBox="0 0 24 24">
	<path fill="#D4A574" d="m22 19l-3-2l3-2zm-7-4l4-6l3 4l-4 3zM5 17l-3 2v-4zm4-2l-3 1l-4-3l3-4zm5-9l4 2l-5 7h-2L6 8l4-2z" />
</svg>`,
          title: 'Fresh Daily',
          description: 'Pastries baked fresh every morning'
        },
        {
          icon: `<svg xmlns="http://www.w3.org/2000/svg" width="35px" height="35px" viewBox="0 0 512 512">
	<path fill="#D4A574" d="M339 99a83 83 0 1 0-102 80.8V464l19 32l19-32V179.8A83.28 83.28 0 0 0 339 99m-59-6a21 21 0 1 1 21-21a21 21 0 0 1-21 21" />
</svg>`,
          title: 'Cozy Atmosphere',
          description: 'Your home away from home'
        }
      ]
    }
  },
  mounted() {
    this.observeSection();
  },
  methods: {
    observeSection() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      }, {
        threshold: 0.15
      });

      observer.observe(this.$refs.storySection);
      observer.observe(this.$refs.imageSection);
      observer.observe(this.$refs.contentSection);
    }
  }
}
</script>

<style scoped>
.our-story-section {
  width: 100%;
  padding: 6rem 2rem;
  background: linear-gradient(135deg, #FFF8DC 0%, #F5F5DC 100%);
}

.story-container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
}

.story-image {
  width: 100%;
  height: 100%;
  min-height: 450px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(111, 78, 55, 0.15);
  opacity: 0;
  transform: translateX(-50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.story-image.visible {
  opacity: 1;
  transform: translateX(0);
}

.story-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.story-image:hover img {
  transform: scale(1.05);
}

.story-content {
  opacity: 0;
  transform: translateX(50px);
  transition: opacity 0.8s ease-out 0.2s, transform 0.8s ease-out 0.2s;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.story-content.visible {
  opacity: 1;
  transform: translateX(0);
}

.story-title {
  font-family: 'Playfair Display', serif;
  font-size: 2.5rem;
  font-weight: 600;
  color: #6F4E37;
  margin-bottom: 1.5rem;
}

.story-text {
  font-family: 'Poppins', sans-serif;
  font-size: 1rem;
  line-height: 1.8;
  color: #D4A574;
  margin-bottom: 3rem;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.feature-item {
  text-align: center;
  opacity: 0;
  animation: fadeInUp 0.6s ease-out forwards;
}

.feature-item:nth-child(1) { animation-delay: 0.3s; }
.feature-item:nth-child(2) { animation-delay: 0.5s; }
.feature-item:nth-child(3) { animation-delay: 0.7s; }

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.feature-icon {
  width: 70px;
  height: 70px;
  margin: 0 auto 1rem;
  background-color: #FFF8DC;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(111, 78, 55, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}


.feature-icon img {
  width: 35px;
  height: 35px;
  object-fit: contain;
}

.feature-title {
  font-family: 'Playfair Display', serif;
  font-size: 1.1rem;
  font-weight: 600;
  color: #6F4E37;
  margin-bottom: 0.5rem;
}

.feature-description {
  font-family: 'Poppins', sans-serif;
  font-size: 0.85rem;
  color: #D4A574;
  line-height: 1.5;
}

/* Responsive */
@media (max-width: 1024px) {
  .story-container {
    grid-template-columns: 1fr;
    gap: 3rem;
  }

  .story-image {
    height: 400px;
  }
}

@media (max-width: 768px) {
  .our-story-section {
    padding: 4rem 1.5rem;
  }

  .story-title {
    font-size: 2rem;
  }

  .story-text {
    font-size: 0.95rem;
  }

  .features-grid {
    grid-template-columns: 1fr;
    gap: 2.5rem;
  }

  .story-image {
    height: 350px;
  }
}

@media (max-width: 480px) {
  .story-title {
    font-size: 1.75rem;
  }

  .story-image {
    height: 300px;
  }
}
</style>